import german from '../i18n/datatables/german';
import regionData from '../map/regions';

import L from "leaflet";
import 'leaflet/dist/leaflet.css';
import FilterTags from "./filter-tags";
import Map from './map'

class InitiativeTable {
    constructor() {
        this.availableFilters = {
            2:  'city',
            4:  'procedure_type',
            5:  'output_long',
            8:  'region',
            9:  'subject_area',
            10: 'status',
        };
    }

    init() {
        this.$table = $("#initiatives");
        this.$searchForm = $("#search-form");
        this.$search = this.$searchForm.find("#search");
        this.$search.val("");

        if (this.$table.length === 0 || this.$search.length === 0) {
            return;
        }

        this.initPlaceTypeAhead();
        this.initDataTable();
        this.initFilter();
        this.initMap();
    }

    initDatePicker(dateTo, dateFrom) {
        let toOptions = {
            locale: 'de',
            format: 'L',
            useCurrent: false
        };
        let fromOptions = {
            locale: 'de',
            format: 'L',
            useCurrent: false
        };

        if (dateTo) {
            toOptions.defaultDate = moment(dateTo, "DD.MM.YYYY");
            setTimeout(() => {
                FilterTags.initFilterEventHandler("dateto");
            }, 500);
        }
        if (dateFrom) {
            fromOptions.defaultDate = moment(dateFrom, "DD.MM.YYYY");
            setTimeout(() => {
                FilterTags.initFilterEventHandler("datefrom");
            }, 500);

        }

        let $dateTo = $("#dateto");

        $dateTo.datetimepicker(toOptions);
        $("#datefrom").datetimepicker(fromOptions);

        $dateTo.on("change.datetimepicker", function (e) {
            $('#datefrom').datetimepicker('maxDate', e.date);
        });
    }

    initMap() {
        this.map = new Map();
        this.map.init();

        if (this.searchFilterEmpty()) {
            this.map.initDefaultMapData();
        }
    }

    initDataTable() {
        let options = {
            language: german,
            processing: true,
            serverSide: true,
            ajax: this.$table.attr("data-loadurl"),
            order: [[6, "desc"], [1, "desc"]],
            initComplete: () => {
                $("#start").fadeIn();
            },
            columnDefs: [
                {
                    targets: 0,
                    orderable: false
                },
                {
                    targets: 1,
                    orderable: true
                },
                {
                    targets: 2,
                    orderable: true
                },
                {
                    targets: 3,
                    orderable: true
                },
                {
                    targets: 4,
                    orderable: true
                },
                {
                    targets: 5,
                    orderable: true
                },
                {
                    targets: 6,
                    orderable: true
                },
                {
                    targets: 7,
                    orderable: false
                },
                {
                    targets: 8,
                    orderable: false,
                    visible: false
                },
                {
                    targets: 9,
                    orderable: false,
                    visible: false
                },
                {
                    targets: 10,
                    orderable: false,
                    visible: false
                },
            ]
        };

        let parameters = this.loadParametersFromCache();

        if (parameters) {
            options.pageLength = parameters.length;
            options.displayStart = parameters.page * parameters.length;
            options.search = {
                "search": parameters.search
            };
            options.searchCols = [];

            for (let [column, id] of Object.entries(this.availableFilters)) {
                options.searchCols[column] = { "search": parameters[id] };
            }

            let searchDate = this.getSearchDate(parameters.date_from, parameters.date_to);
            this.initDatePicker(parameters.date_from, parameters.date_to);

            options.searchCols[6] = { "search": searchDate };
        }
        else {
            this.initDatePicker();
        }

        if (this.isRegionHidden()) {
            if (!options.searchCols) {
                options.searchCols = [];
            }

            options.searchCols[8] = { 'search': $('#region').val() }
        }

        this.$table.DataTable(options);

        this.$searchForm.on("submit", event => {
            event.preventDefault();
            this.search();
        });

        this.$searchForm.find("input, select").not("#city, [type='checkbox']").on("change keyup", () => {
            this.setFilteredAttribute();

            clearTimeout(this.searchInputTimeout);
            this.searchInputTimeout = setTimeout(this.search.bind(this), 800);

            if (this.searchFilterEmpty()) {
                this.map.initDefaultMapData(true);
            }
        });

        this.$searchForm.find("#city").on("change keyup", () => {
            this.setFilteredAttribute();

            if (this.searchFilterEmpty()) {
                this.map.initDefaultMapData(true);
            }
        });

        this.$searchForm.find(".datepicker").on("change.datetimepicker", event => {
            this.setFilteredAttribute();
            this.search();
        });

        this.$cityInput.on("autocompleteselect", () => {
            this.setFilteredAttribute();
            setTimeout(() => {
                FilterTags.initFilterEventHandler(this.$cityInput.attr("id"));
                this.search();
            },500);
        });

        this.$table.on('page.dt', () => {
            this.saveParametersToCache();
        });

        this.$table.on('length.dt', () => {
            this.saveParametersToCache();
        });

        this.$table.on('removed-filter', () => {
            this.setFilteredAttribute();
            this.search();

            if (this.searchFilterEmpty()) {
                this.map.initDefaultMapData(true);
                this.clearParameterCache()
            }
        });

        this.$table.on('draw.dt', () => {
            if (!this.searchFilterEmpty()) {
                this.map.drawMarkers(true);
            }
        });
    }

    search() {
        let dataTable = this.$table.DataTable();

        let dateFromValue = this.$searchForm.find("#datefrom").val();
        let dateToValue = this.$searchForm.find("#dateto").val();

        let searchDate = this.getSearchDate(dateFromValue, dateToValue);

        this.saveParametersToCache();

        dataTable
            .search(this.$search.val())
            .columns(2).search(this.$searchForm.find("#city").val())
            .columns(4).search(this.$searchForm.find("#procedure_type").val())
            .columns(5).search(this.$searchForm.find("#output_long").val())
            .columns(6).search(searchDate)
            .columns(8).search(this.$searchForm.find("#region").val())
            .columns(9).search(this.$searchForm.find("#subject_area").val())
            .columns(10).search(this.$searchForm.find("#status").val())
            .draw();
    }

    searchFilterEmpty() {
        for (const [index, filter] of Object.entries(this.availableFilters)) {
            if (this.$searchForm.find("#" + filter).val()) {
                return false;
            }
        }

        return !(
            this.$search.val() ||
            this.$searchForm.find("#datefrom").val() ||
            this.$searchForm.find("#dateto").val()
        );
    }

    getSearchDate(dateFromValue, dateToValue) {
        if (dateFromValue.trim() !== "") {
            let parts = dateFromValue.split(".");

            if (parts.length === 3 && parts[2] !== undefined && parts[2].length === 4) {
                dateFromValue = parts[2];
            }
            else {
                dateFromValue = undefined;
            }
        }

        if (dateToValue.trim() !== "") {
            let parts = dateToValue.split(".");

            if (parts.length === 3 && parts[2] !== undefined && parts[2].length === 4) {
                dateToValue = parts[2];
            }
            else {
                dateToValue = undefined;
            }
        }

        let searchDate = "";

        if (dateFromValue && dateToValue) {
            searchDate = dateFromValue + "-" + dateToValue;
        }
        else if (dateFromValue) {
            searchDate = dateFromValue + "-";
        }
        else if (dateToValue) {
            searchDate = "-" + dateToValue;
        }

        return searchDate;
    }

    clearParameterCache() {
        if (window.sessionStorage) {
            window.sessionStorage.clear();
        }
    }

    saveParametersToCache() {
        if (window.sessionStorage) {
            // Set filter
            sessionStorage.setItem("search_filter.search", this.$search.val());
            sessionStorage.setItem("search_filter.date_from", this.$searchForm.find("#datefrom").val());
            sessionStorage.setItem("search_filter.date_to", this.$searchForm.find("#dateto").val());

            let regionHidden = this.isRegionHidden();

            for (let [column, id] of Object.entries(this.availableFilters)) {
                if (id === 'region' && regionHidden) {
                    continue;
                }

                sessionStorage.setItem("search_filter." + id, this.$searchForm.find("#" + id).val());
            }

            // Set datatable parameters
            let dataTable = this.$table.DataTable();
            let pageInfo = dataTable.page.info();

            sessionStorage.setItem("datatable.page", pageInfo.page);
            sessionStorage.setItem("datatable.length", pageInfo.length);
        }
    }

    loadParametersFromCache() {
        if (window.sessionStorage) {
            if (sessionStorage.getItem("search_filter.search")) {
                this.$search.val(sessionStorage.getItem("search_filter.search"));
            }
            let regionHidden = this.isRegionHidden();
            for (let [column, id] of Object.entries(this.availableFilters)) {
                if (id === 'region' && regionHidden) {
                    continue;
                }

                if (sessionStorage.getItem("search_filter." + id)) {
                    this.$searchForm.find("#" + id).val(sessionStorage.getItem("search_filter." + id));
                    FilterTags.initFilterEventHandler(id);
                }
            }

            $("#initiatives-extended-filter .filter").first().trigger("change");

            if (sessionStorage.getItem("datatable.page") && sessionStorage.getItem("datatable.length")) {
                let result = {
                    page: sessionStorage.getItem("datatable.page"),
                    length: sessionStorage.getItem("datatable.length"),
                    search: sessionStorage.getItem("search_filter.search"),
                    date_from: sessionStorage.getItem("search_filter.date_from"),
                    date_to: sessionStorage.getItem("search_filter.date_to")
                }

                for (let [column, id] of Object.entries(this.availableFilters)) {
                    result[id] = sessionStorage.getItem("search_filter." + id);
                }

                return result;
            }
        }

        return false;
    }

    isRegionHidden() {
        return $('#region').is('[type=hidden]');
    }

    initPlaceTypeAhead() {
        this.$cityInput = $('#city');

        let typeAheadUrl = this.$cityInput.attr("data-typeahead-url");

        this.$cityInput.autocomplete({
            source: function (request, response) {
                $.post(typeAheadUrl, {
                    name: request.term,
                    flat: true
                }, response);
            }
        });
    }

    initFilter() {
        $('#initiatives-extended-filter-open-btn, #initiatives-extended-filter .close i').on('click', function() {
            $('#initiatives-extended-filter').toggle("blind");

            let caret = $('#initiatives-extended-filter-open-btn i.caret');

            caret.toggleClass('fa-caret-up', !(caret.hasClass('fa-caret-up')));
            caret.toggleClass('fa-caret-down', !(caret.hasClass('fa-caret-down')));
            if (caret.hasClass('fa-caret-up')){
                $('#initiatives-extended-filter-open-btn').addClass('active');
            }
            else {
                $('#initiatives-extended-filter-open-btn').removeClass('active');
            }
        });
    }

    setFilteredAttribute() {
        if (!this.searchFilterEmpty()) {
            this.map.$map.attr("data-filtered", "true");
        }
        else {
            this.map.$map.attr("data-filtered", "false");
        }
    }
}

export default InitiativeTable;